import React from "react"
import {
  Flex, Text, Image,
} from "@chakra-ui/react"
import battery from "assets/images/phone/battery.png"
import signal from "assets/images/phone/signal.png"
import wifi from "assets/images/phone/wifi.png"
import { format } from "date-fns"

type Props = {
  light?: boolean
}

const StatusBar = ({ light }: Props) => (
  <Flex justifyContent="space-between" px={14} color={light ? "white" : undefined}>
    <Text fontSize="lg">{format(new Date(), "HH:mm")}</Text>
    <Flex gap={1} filter={light ? "invert(1)" : undefined}>
      <Image src={signal} h={5} w="auto" alt="" />
      <Image src={wifi} h={5} w="auto" alt="" />
      <Image src={battery} h={6} w="auto" alt="" />
    </Flex>
  </Flex>
)

export default StatusBar
